/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_NameInputs */

const en_region_name = /** @type {(inputs: Region_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region name`)
};

const es_region_name = /** @type {(inputs: Region_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de la region`)
};

/**
* | output |
* | --- |
* | "Region name" |
*
* @param {Region_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const region_name = /** @type {((inputs?: Region_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_region_name(inputs)
	return es_region_name(inputs)
});